export default __webpack_public_path__ + "static/media/x-circle.61f0398a.svg";